import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { GlueConfigurationService } from './glue-configuration.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ContactUsService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly glueConfiguration: GlueConfigurationService = inject(GlueConfigurationService);

  glueUrl: string = this.glueConfiguration.getEndpointUrl();

  private static handleError(error: any): Observable<any> {
    return throwError(() => new Error(error.message || error));
  }

  postContactUsData(data: any): Observable<any> {
    const newBody: string = JSON.stringify(data);
    const url: string = this.glueUrl + '/contact-us';

    return this.http.post<any>(url, newBody).pipe(
      catchError(ContactUsService.handleError),
    );
  }

  postContactUsGeneralData(data: any): Observable<any> {
    const newBody: string = JSON.stringify(data);
    const url: string = this.glueUrl + '/contact-us-general';

    return this.http.post<any>(url, newBody).pipe(
      catchError(ContactUsService.handleError),
    );
  }
}
